export default __webpack_public_path__ + "static/media/greenPT.37ba7f29.png";